import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Верба Олександр',
  role: 'Голова суддівської колегії',
  email: 'olverba@gmail.com'
}, {
  name: 'Копейка Геннадій',
  role: 'МСМК, суддя міжнародної категорії',
  email: 'g.kopeika@umcf.org.ua'
}, {
  name: 'Горбенко Мстислав',
  role: 'МСМК, суддя національної категорії',
  email: 'm.gorbenko@umcf.org.ua'
}];
export function AlpinismJudgesBoard() {
  return <FederationMembersPage title="Суддівська колегія" subtitle="Суддівська колегія комітету альпінізму ФАіСУ" members={members} data-id="element-422" />;
}